module.exports = __webpack_public_path__ + "static/onion_y-af561f584c2f3cc3539c0d225de7a20e.png";